<template>
    <div style="display: flex; flex-direction: column; height: 100%;">
      <van-tabs v-model="activeName" type="card" color="#329DFF" style="flex-grow: 1;background-color: #C4C4C4;" @click="clickTab">
        <van-tab title="工单基本信息" name="basic">
          <wx-work-basicinfo-panel style="height: calc(100vh - 86px);" :work="work" :brand="brand" ref="basicPane"></wx-work-basicinfo-panel>
        </van-tab>
        <van-tab title="维修信息" name="loss">
          <wx-loss-determ-panel style="height: calc(100vh - 131px);" v-loading="work.basicPaintWorkHour === null" :work="work" :loss-determ="work.lossDeterm"></wx-loss-determ-panel>
        </van-tab>
      </van-tabs>
      <div style="background-color: #C4C4C4;height: 40px;padding-top: 10px;" v-if="activeName==='loss'">
            <div class="DocBtnAdd" @click="save()">确认开单</div>
        </div>
    </div>
</template>

<script>
  import { Button, NavBar, Popup, Tab, Tabs, Toast } from 'vant'
  import { firstModel, getData, addWork } from '@/utils/request'
  import { Work } from '@/store/objdef/objectDef'
  import WxWorkBasicinfoPanel from '@/views/wx/work-add/WxWorkBasicinfoPanel'
  import WxLossDetermPanel from '@/views/wx/work-add/WxLossDetermPanel'

  export default {
    name: 'WxWorkAdd',
    components: {
      WxWorkBasicinfoPanel,
      WxLossDetermPanel,
      [NavBar.name]: NavBar,
      [Tab.name]: Tab,
      [Tabs.name]: Tabs,
      [Button.name]: Button,
      [Popup.name]: Popup,
      [Toast.name]: Toast
    },
    props: {

    },
    data () {
      return {
        activeName: 'basic',
        work: new Work()
      }
    },
    created () {
        var _that = this
        if (_that.$store.state.data.BrandModel === undefined) {
             _that.$store.dispatch('data/kvList', 'BrandModel')
        }
        for (const brandId of _that.$store.state.shop.carBandIds) {
          firstModel(brandId).then(response => {
            if (response.data) {
              _that.work.brandModel = [brandId, response.data.name]
            }
          })
        }

        if (this.$store.state.data.SheetMetalDamageDegree === undefined) {
            this.$store.dispatch('data/kvList', 'SheetMetalDamageDegree')
        }
        if (this.$store.state.data.PaintDamageDegree === undefined) {
            this.$store.dispatch('data/kvList', 'PaintDamageDegree')
        }
        if (this.$store.state.data.PARTS_TYPE === undefined) {
            this.$store.dispatch('data/kvList', 'PARTS_TYPE')
        }
        if (this.$store.state.data.Parts === undefined) {
            this.$store.dispatch('data/kvList', 'Parts')
        }
        getData('basicPaintWorkHour').then(response => {
          this.work.basicPaintWorkHour = response.data
        })
    },
    beforeMount () {
        this.brand = []
    },
    methods: {
      clickTab () {
        var _this = this
        if (_this.activeName === 'basic') return

        _this.workRef.validate(valid => {
          if (!valid) {
            Toast.fail('请先完成基本信息填写')
            _this.$nextTick(() => {
                _this.activeName = 'basic'
            })
          }
        })
      },
      save (callback) {
        if (this.work.lossDeterm.partsList.length === 0) {
            Toast.fail('请选择需要维修的部位')
            return
        }

        this.work.enterTime = new Date()
        if (this.saveLoading) return
        this.saveLoading = true

        this.work.carNo = this.work.carNo.trim()
        var _this = this
        addWork(this.$_.cloneDeep(this.work)).then(response => {
          if (callback) {
            // this.printTarget.popTitle = '工单：' + (response.data.extraId || response.data.id)
            // this.work.consultantName = response.data.consultantName
            // this.work.id = response.data.id
            // callback()
            Toast.fail('新增工单成功')
            _this.$emit('btnpageshow')
          } else {
            _this.$emit('btnpageshow')
          }
        }).finally(() => {
          this.saveLoading = false
        })
      }
    },
    computed: {
      workRef () {
        return this.$refs.basicPane.$refs.work
      }
    }
  }
</script>

<style lang="scss" scoped>
.basicInfo{
    background-color:white;
    width: 96%;
    margin: 0px auto;
    border: 1px solid white;
    border-radius: 20px;
}
/deep/ .van-tabs__nav--card{
    margin:0 0;
}
.DocBtnAdd{
            width: 150px;
            height: 30px;
            line-height: 30px;
            color: white;
            border: 1px solid #329DFF;
            border-radius: 10px;
            background-color: #329DFF;
            text-align: center;
            margin: 0px auto;
        }
</style>
